/*
 *   File : portfolio.js
 *   Author : https://evoqins.com
 *   Description : user portfolio card component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import { memo, useEffect } from "react"

// Component
import { Icon } from "../Icon";

// COLORS
import Colors from "../../Style/color.scss"

function PortfolioCard({ type, title, summary, showValues, wrapperClassName, handleToggleShowValues, handleNavigateToAnalysis }) {

    return (

        <div div className={`row p-0 ${wrapperClassName}`}>
            <div className="col">
                <div className="e-border-radius-24 e-bg-egyptian-blue p-1 ">
                    <div className="e-bg-white e-border-radius-24 p-3">
                        <div className="d-flex  row-gap-2  justify-content-between align-items-sm-center align-items-start e-border-bottom-1px-platinum-gray pb-3">
                            <div>
                                <p className="e-text-sonic-silver e-font-12-res e-font-16 e-primary-font-inter e-font-weight-600 mb-sm-2 mb-0">
                                    {title}
                                </p>
                                <span className={`e-text-eerie_black d-flex gap-2 e-font-14-res align-items-center  e-primary-font-inter e-font-weight-700 e-font-32 line-height-40px`}>
                                    {
                                        summary?.current_amount || summary.current_portfolio_value ?
                                            <>

                                                {showValues ? (summary?.current_amount_text || summary.current_portfolio_value_text) : (summary?.masked_current_amount || summary.current_portfolio_value)}
                                                <Icon icon={showValues ? "eye-open" : "eye-hide"} className="cursor-pointer width-20px width-16px-res" onClick={handleToggleShowValues} />
                                            </>
                                            :
                                            "₹0"
                                    }
                                </span>
                            </div>
                            {
                                type === 1 &&
                                <span className="d-flex gap-6px align-items-center e-text-neutral-navy e-font-10-res e-font-14 e-primary-font-inter e-font-weight-400 e-border-1px-bright-silver line-height-16px  e-border-radius-8 py-1 py-sm-2 padding-12px-lr padding-6px-lr-res  cursor-pointer"
                                    onClick={handleNavigateToAnalysis} >
                                    <Icon icon={"portfolio_analyse"} className="width-16px width-12px-res cursor-pointer line-height-16px" />
                                    Portfolio analyse
                                </span>
                            }
                        </div>

                        <div className="row  justify-content-between mt-3 row-gap-3">
                            <div className="col-6 col-sm-auto w-100-res ">
                                <p className="e-text-onyx e-font-14-res e-font-16 e-alt-font-poppins e-font-weight-400 line-height-20px mb-sm-2 mb-0">
                                    Invested {type === 2 ? "value" : ""}
                                </p>
                                <span className="e-text-eerie_black e-font-12-res e-font-14 e-primary-font-inter e-font-weight-700 line-height-22px">
                                    {
                                        summary?.invested_amount || summary.invested_value ?
                                            <>
                                                {showValues ? (summary?.invested_amount_text || summary.invested_value_text) : summary?.masked_invested_amount}
                                            </>
                                            :
                                            "₹0"
                                    }
                                </span>
                            </div>
                            {
                                type === 1 ?
                                    <div className="col-6 col-sm-auto w-100-res ">
                                        <p className="e-text-onyx e-font-14-res e-font-16 e-alt-font-poppins e-font-weight-400 line-height-20px mb-sm-2 mb-1">
                                            Total Returns
                                        </p>
                                        <span className={`${summary?.returns_amount >= 0 ? "e-text-bottle-green" : "e-text-red"} d-flex  align-items-center e-primary-font-inter e-font-12-res  e-font-14 line-height-22px `}>
                                            {
                                                summary?.returns_amount ?
                                                    <>
                                                        <Icon icon="returns-arrow"
                                                            size={"12px"}
                                                            className={summary?.returns_amount ? "" : "transform-rotate-180"}
                                                            color={summary?.returns_amount ? Colors.bottle_green : Colors.red} />
                                                        <span className="ps-1 e-font-weight-700">{summary?.returns_amount >= 0 ? "+" : "-"} {showValues ? summary?.returns_amount_text : summary?.masked_returns_amount}</span>
                                                        <span className="e-font-weight-500">({showValues ? summary?.returns_percentage_text : summary?.masked_returns_percentage})</span>
                                                    </>
                                                    :
                                                    "₹0"
                                            }
                                        </span>
                                    </div>
                                    :
                                    <div className="col-6 col-sm-auto w-100-res ">
                                        <p className="e-text-onyx e-font-14-res e-font-16 e-alt-font-poppins e-font-weight-400 line-height-20px mb-sm-2 mb-1">
                                            Total gain
                                        </p>
                                        <span className={`e-text-eerie_black d-flex e-font-weight-700  align-items-center e-primary-font-inter e-font-12-res  e-font-14 line-height-22px `}>
                                            {
                                                summary?.total_gain ?
                                                    <span className="ps-1">{showValues ? summary?.total_gain_text : summary?.masked_total_gain}</span>
                                                    :
                                                    "₹0"
                                            }
                                        </span>
                                    </div>
                            }

                            {
                                type === 1 &&
                                <div className="col-6 col-sm-auto w-100-res ">
                                    <p className="e-text-onyx e-font-14-res e-font-16 e-alt-font-poppins e-font-weight-400 line-height-20px mb-sm-2 mb-1">
                                        1D Returns
                                    </p>
                                    <span className={`${summary?.one_day_returns < 0 ? "e-text-red" : "e-text-bottle-green"} d-flex align-items-center e-primary-font-inter e-font-12-res  e-font-14 line-height-22px `}>

                                        {
                                            summary?.one_day_returns ?
                                                <>
                                                    <Icon icon={"returns-arrow"}
                                                        size={"12px"}
                                                        className={summary?.one_day_returns >= 0 ? "" : "transform-rotate-180"}
                                                        color={summary?.one_day_returns >= 0 ? Colors.bottle_green : Colors.red} />
                                                    <span className="ps-1 e-font-weight-700">{showValues ? summary?.one_day_returns_text : summary?.masked_one_day_returns}</span>
                                                    <span className="e-font-weight-500">({showValues ? summary?.one_day_returns_percentage_text : summary?.masked_one_day_returns_percentage})</span>

                                                </>
                                                :
                                                "₹0"
                                        }
                                    </span>
                                </div>
                            }
                            <div className="col-6 col-sm-auto w-100-res ">
                                <p className="e-text-onyx e-font-16 e-font-14-res e-alt-font-poppins e-font-weight-400 line-height-20px mb-sm-2 mb-0">
                                    XIRR
                                </p>
                                <span className="e-text-eerie_black e-font-14 e-font-12-res e-primary-font-inter e-font-weight-700 line-height-22px">

                                    {
                                        summary?.xirr_text ?
                                            <>
                                                {showValues ? summary?.xirr_text : summary?.masked_xirr}
                                            </>
                                            :
                                            "0%"
                                    }
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default memo(PortfolioCard);